<template>
  <div class="detail">
    <div class="detail-module-wrapper">
      <div class="split-line" />
      <!-- Product Specifications -->
      <Specifications :list="detailInfo.productAttribute" />

      <div class="product-detail__header">
        <p class="product-detail__title">
          Product Details
        </p>
        <p
          class="product-detail__view"
          @click="open('description', 0)"
        >
          View all
        </p>
      </div>
      <ProductDetailImages
        class="product-detail__images"
        :images="descriptionImages"
      />
      <FactoryCard
        class="product-detail__factory"
        :factory-id="detailInfo.sellerOpenId"
      />
    </div>
  </div>
</template>

<script setup>
import Specifications from './Specifications.vue'
import ProductDetailImages from './ProductDetailImages.vue'
import FactoryCard from './FactoryCard.vue'
import { useImagePreview } from './OfferImagePreview'

defineProps({
  detailInfo: {
    type: Object,
    default: () => ({})
  },
  descriptionImages: {
    type: Array,
    default: () => []
  }
})

const { open } = useImagePreview()
</script>

<style lang='less' scoped>
.detail {
  .detail-module-wrapper {
    padding-bottom: 48px;

    .split-line {
      margin: 32px 0;
      height: 1px;
      background-color: #EBF1F5;

      @media (min-width: 1920px) {
        margin: 48PX 0 32PX;
      }
    }
  }
}

.product-detail {
  &__header {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
  }

  &__title {
    font-family: mon-700;
    font-size: 18px;
    line-height: 24px;
    color: #232323;
  }

  &__view {
    font-family: mon-600;
    font-size: 11px;
    line-height: 14px;
    text-decoration: underline;
    color: #232323;
    cursor: pointer;

    &:hover {
      color: #004F9A;
    }
  }

  &__images {
    margin-top: 20px;
  }

  &__factory {
    margin-top: 48px;
  }
}
</style>
